function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_260",
  "data-name": "Group 260",
  transform: "translate(-21.25 -222.633)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_248",
  "data-name": "Group 248",
  transform: "translate(21.25 222.633)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_317",
  "data-name": "Path 317",
  d: "M21.252,380.546h0v4.46h0a10.321,10.321,0,0,0,10.439-10.2V354.242H27.127v20.564A5.808,5.808,0,0,1,21.252,380.546Z",
  transform: "translate(-21.25 -346.006)",
  fill: "#2c3589"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_18",
  "data-name": "Ellipse 18",
  cx: 2.306,
  cy: 2.306,
  r: 2.306,
  transform: "translate(5.829 0)",
  fill: "#2c3589"
})), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_19",
  "data-name": "Ellipse 19",
  cx: 2.306,
  cy: 2.306,
  r: 2.306,
  transform: "translate(122.823 248.954)",
  fill: "#2c3589"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_318",
  "data-name": "Path 318",
  d: "M1533.977,370.748a6.9,6.9,0,1,1,9.763,0l3.339,3.339a11.625,11.625,0,1,0-16.441,0Z",
  transform: "translate(-1413.874 -123.672)",
  fill: "#2c3589"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_319",
  "data-name": "Path 319",
  d: "M695.16,358.664h0v-4.422h0a10.28,10.28,0,0,0-10.439,10.114v12.413h4.565V364.356A5.785,5.785,0,0,1,695.16,358.664Z",
  transform: "translate(-622.779 -123.372)",
  fill: "#2c3589"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_320",
  "data-name": "Path 320",
  d: "M1334,249.556a5.874,5.874,0,0,1-5.874-5.874v-8.09h5.506V230.87h-5.506v-8.237h-4.565V226.3h0v4.565h0v12.812A10.439,10.439,0,0,0,1334,254.12h0v-4.565Z",
  transform: "translate(-1222.435)",
  fill: "#2c3589"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_321",
  "data-name": "Path 321",
  d: "M900.022,354.242a11.269,11.269,0,1,0,0,22.527,11.822,11.822,0,0,0,6.9-2.2v2.2h4.722V365.505A11.449,11.449,0,0,0,900.022,354.242Zm0,17.952a6.692,6.692,0,1,1,6.9-6.689A6.8,6.8,0,0,1,900.022,372.194Z",
  transform: "translate(-814.111 -123.372)",
  fill: "#2c3589"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_322",
  "data-name": "Path 322",
  d: "M262.27,354.242A11.269,11.269,0,1,0,273.9,365.505,11.449,11.449,0,0,0,262.27,354.242Zm0,17.952a6.692,6.692,0,1,1,6.9-6.689A6.8,6.8,0,0,1,262.27,372.194Z",
  transform: "translate(-215.039 -123.372)",
  fill: "#2c3589"
}));

var SvgJoratoLogo = function SvgJoratoLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115.359,
    height: 39,
    viewBox: "0 0 115.359 39",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJoratoLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jorato-logo.3373d404.svg";
export { ForwardRef as ReactComponent };